<script>
export default {
  name: 'TeacherListItemsName',
  inject: ['teacher'],
  props: {
    classes: {
      type: String,
      default: 'lg:text__headline-4-md--bold text__headline-4-xs--bold'
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    link () {
      return this.$links.tutor_profile_link(this.$nuxt, this.teacher?.username)
    }
  }
}
</script>

<template>
  <div class="teacher-items-title">
    <h3 class="teacher-items-title__name text-overflow-dots" :class="classes">
      <nuxt-link :to="link">
        {{ teacher.fullName }}
      </nuxt-link>
      <BaseIcon v-if="showIcon" name="verified" colot="primary" class="ml-2" size="xs-sm" />
    </h3>
  </div>
</template>

<style scoped lang="scss">
.teacher-items-title {
  @apply flex items-center justify-between;
  &__name {
    @apply text-title w-full lg:w-auto;
  }
}
</style>
